// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see InquiryVerifyStartEvent
 */
export var InquiryVerifyStart = function () { return ({
    name: "Inquiry Verify Start",
    parameters: {
        cdf_entity: "Inquiry",
        cdf_action: "Verify",
    }
}); };
/**
 * @see InquiryVerifyCreateEvent
 */
export var InquiryVerifyCreate = function () { return ({
    name: "Inquiry Verify Create",
    parameters: {
        cdf_entity: "Inquiry",
        cdf_action: "Verify",
    }
}); };
/**
 * @see InquiryVerifySubmitEvent
 */
export var InquiryVerifySubmit = function (_a) {
    var verificationType = _a.verificationType;
    return ({
        name: "Inquiry Verify Submit",
        parameters: {
            cdf_entity: "Inquiry",
            cdf_action: "Verify",
            verification_type: verificationType !== undefined && verificationType !== null ? verificationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
